import uniqid from 'uniqid'
import axios from 'axios'

export default {
  namespaced: true,
  state: {
    exerciseId: null,
    shortId: null,
    exerciseTitle: '',
    bots: [],
    answers: [],
    path: [],
    currentBotId: null,
    saving: false,
    backgroundStore: [],
    personStore: [],
    activePlayModes: null,
    bottomBarState: {
      question: false,
      answer_0: false,
      answer_1: false,
      answer_2: false,
      answer_3: false,
    }
  },
  mutations: {
    //BOT
    ADD_NEW_BOT: (state, object) => {
      state.bots.push(object);
    },

    CHANGE_CURRENT_BOT: (state, id) => {
      state.currentBotId = id;
    },

    GO_TO_NEXT_BOT: (state, nextId) => {
      state.path.push(state.currentBotId);
      state.currentBotId = nextId;
    },

    BOT_SAVE_TEXT: (state, { text, id }) => {
      let botIndex = state.bots.findIndex(bot => {
        return bot.id === id
      });
      state.bots[botIndex].text = text;
    },

    BOT_SAVE_TIME: (state, { time, id }) => {
      let botIndex = state.bots.findIndex(bot => {
        return bot.id === id;
      });
      state.bots[botIndex].recordingTime = time;
    },

    BOT_CHANGE_SWITCH: (state, { switchState, id }) => {
      let botIndex = state.bots.findIndex(bot => {
        return bot.id === id;
      });
      state.bots[botIndex].audioType = switchState;
    },

    QUESTION_CHANGE_BOTTOM_BAR: (state) => {
      state.bottomBarState.question = !state.bottomBarState.question;
    },

    BOT_CHANGE_AUDIO_DATA: (state, { audioData, id }) => {
      let botIndex = state.bots.findIndex(bot => {
        return bot.id === id;
      });
      state.bots[botIndex].audioData = audioData;
    },

    DELETE_BOT_ANSWERS: (state, botId) => {
      let botIndex = state.bots.findIndex(bot => {
        return bot.id === botId;
      });
      let answers = state.bots[botIndex].answers;
      answers.forEach(localAnswer => {
        let answerIndex = state.answers.findIndex(globalAnswer => {
          return globalAnswer.id === localAnswer;
        });
        state.answers.splice(answerIndex, 1);
      });
    },

    DELETE_BOT: (state, botId) => {
      let botIndex = state.bots.findIndex(bot => {
        return bot.id === botId;
      });
      state.bots.splice(botIndex, 1);
    },

    DELETE_BOT_REFS: (state, botId) => {
      state.answers.forEach(answer => {
        if(answer.next == botId) {
          answer.next = null;
        }
      });
    },

    BOT_CHANGE_BG: (state, { object, id }) => {
      let botIndex = state.bots.findIndex(bot => {
        return bot.id === id;
      });
      state.bots[botIndex].background = object;
    },

    SAVE_TO_BG_STORE: (state, data) => {
      state.backgroundStore.push(data);
    },

    BOT_CHANGE_PERSON: (state, { object, id }) => {
      let botIndex = state.bots.findIndex(bot => {
        return bot.id === id;
      });
      state.bots[botIndex].person = object;
    },

    SAVE_TO_PERSON_STORE: (state, data) => {
      state.personStore.push(data);
    },

    BOT_CHANGE_VOICE: (state, { voice, id }) => {
      let botIndex = state.bots.findIndex(bot => {
        return bot.id === id;
      });
      state.bots[botIndex].selectedVoice = voice;
    },

    //ANSWER
    CREATE_NEW_ANSWER: (state, text) => {
      let botIndex = state.bots.findIndex(bot => {
        return bot.id === state.currentBotId;
      });
      let lastAnswer = state.answers[state.answers.length - 1];
      let selectedVoice = { name: 'Google UK English Female', lang: 'en-GB' };
      if(lastAnswer) {
        selectedVoice = lastAnswer.selectedVoice;
      }
      let newAnswer = {
        id: uniqid(),
        text: text,
        hint: '',
        next: null,
        audioData: null,
        audioType: 'bot',
        recordingTime: 0,
        selectedVoice,
        recordDisable: false,
        feedback: false,
        feedbackStatus: 'info',
        feedbackMessage: ''
      }
      state.answers.push(newAnswer);
      state.bots[botIndex].answers.push(newAnswer.id);
    },

    ADD_NEXT_TO_ANSWER: (state, { answerId, id }) => {
      let answerIndex = state.answers.findIndex(answer => {
        return answer.id === answerId
      });
      state.answers[answerIndex].next = id;
    },

    ADD_EXISTING_TO_ANSWER: (state, { answerId, nextId }) => {
      let answerIndex = state.answers.findIndex(answer => {
        return answer.id === answerId;
      });
      state.answers[answerIndex].next = nextId;
    },

    DELETE_ANSWER: (state, answerId) => {
      let botIndex = state.bots.findIndex(bot => {
        return bot.id === state.currentBotId;
      });
      let answerIndex = state.bots[botIndex].answers.findIndex(answer => {
        return answer === answerId
      });
      state.bots[botIndex].answers.splice(answerIndex, 1);

      let answerIndex2 = state.answers.findIndex(answer => {
        return answer.id === answerId
      });
      state.answers.splice(answerIndex2, 1);
    },

    ANSWER_SAVE_TEXT: (state, { text, id, type }) => {
      let answerIndex = state.answers.findIndex(answer => {
        return answer.id === id;
      });
      if(type == 'text') {
        state.answers[answerIndex].text = text;
      } else {
        state.answers[answerIndex].hint = text;
      }
      
    },

    ANSWER_SAVE_TIME: (state, { time, id }) => {
      let answerIndex = state.answers.findIndex(answer => {
        return answer.id === id;
      });
      state.answers[answerIndex].recordingTime = time;
    },

    ANSWER_CHANGE_SWITCH: (state, { switchState, id }) => {
      let answerIndex = state.answers.findIndex(answer => {
        return answer.id === id;
      });
      state.answers[answerIndex].audioType = switchState;
    },

    ANSWER_CHANGE_AUDIO_DATA: (state, { audioData, id }) => {
      let answerIndex = state.answers.findIndex(answer => {
        return answer.id === id;
      });
      state.answers[answerIndex].audioData = audioData;
    },

    ANSWER_CHANGE_VOICE: (state, { voice, id }) => {
      let answerIndex = state.answers.findIndex(answer => {
        return answer.id === id;
      });
      state.answers[answerIndex].selectedVoice = voice;
    },

    ANSWER_CHANGE_BOTTOM_BAR: (state, index) => {
      switch(index) {
        case 0: state.bottomBarState.answer_0 = !state.bottomBarState.answer_0; break;
        case 1: state.bottomBarState.answer_1 = !state.bottomBarState.answer_1; break;
        case 2: state.bottomBarState.answer_2 = !state.bottomBarState.answer_2; break;
        case 3: state.bottomBarState.answer_3 = !state.bottomBarState.answer_3; break;
      }
    },

    ANSWER_CHANGE_RECORD_DISABLE: (state, { disableState, id }) => {
      let answerIndex = state.answers.findIndex(answer => {
        return answer.id === id;
      });
      state.answers[answerIndex].recordDisable = disableState;
    },

    ANSWER_CHANGE_FEEDBACK: (state, { feedback, id }) => {
      let answerIndex = state.answers.findIndex(answer => {
        return answer.id === id;
      });
      state.answers[answerIndex].feedback = feedback;
    }, 

    ANSWER_CHANGE_FEEDBACK_STATUS: (state, { feedbackStatus, id }) => {
      let answerIndex = state.answers.findIndex(answer => {
        return answer.id === id;
      });
      state.answers[answerIndex].feedbackStatus = feedbackStatus;
    },
    
    ANSWER_CHANGE_FEEDBACK_MESSAGE: (state, { feedbackMessage, id }) => {
      let answerIndex = state.answers.findIndex(answer => {
        return answer.id === id;
      });
      state.answers[answerIndex].feedbackMessage = feedbackMessage;
    },
    
    //PATH
    ADD_TO_PATH: (state) => {
      state.path.push(state.currentBotId);
    },

    PATH_BACK: (state) => {
      state.currentBotId = state.path[state.path.length - 1];
      state.path.pop();
    },

    //DB
    SAVING_START: (state) => {
      state.saving = true;
    },

    SAVING_END: (state) => {
      state.saving = false;
    },

    CHANGE_TITLE: (state, title) => {
      state.exerciseTitle = title;
    },

    // State
    CLEAR_STATE: (state) => {
      state.exerciseId = null;
      state.exerciseTitle = '';
      state.bots = [];
      state.answers = [];
      state.path = [];
      state.currentBotId = null;
      state.saveError = false;
      state.saving = false;
      state.backgroundStore = [];
      state.personStore = [];
      state.activePlayModes = null;
      state.bottomBarState = {
        question: false,
        answer_0: false,
        answer_1: false,
        answer_2: false,
        answer_3: false,
      }
    },
    LOAD_DATA: (state, data) => {
      state.exerciseId = data._id;
      state.shortId = data.shortId;
      state.exerciseTitle = data.title;
      state.bots = data.bots;
      state.answers = data.answers;
      state.currentBotId = data.bots[0].id;
      state.path = [];
      state.saveError = false;
      state.saving = false;
      state.backgroundStore = data.backgroundStore;
      state.personStore = data.personStore;
      state.activePlayModes = data.activePlayModes || {
        play: true,
        learn: true,
        record: true
      }
    }
  },
  actions: {
    //BOT
    addNextBot: ({ commit, state }, answerId) => {
      let currentBot = state.bots.filter(bot => {
        return bot.id === state.currentBotId;
      })
      let id = uniqid();
      let newBot = {
        id: id,
        text: '',
        audioData: null,
        answers: [],
        audioType: 'bot',
        recordingTime: 0,
        background: currentBot[0].background,
        person: currentBot[0].person,
        selectedVoice: currentBot[0].selectedVoice
      };
      commit('ADD_NEXT_TO_ANSWER', { answerId, id });
      commit('ADD_TO_PATH');
      commit('ADD_NEW_BOT', newBot);
      commit('CHANGE_CURRENT_BOT', id);
    },

    botSaveText: ({ commit }, { text, id }) => {
      commit('BOT_SAVE_TEXT', { text, id });
    },

    botSaveTime: ({ commit }, { time, id }) => {
      commit('BOT_SAVE_TIME', { time, id });
    },

    botChangeSwitch: ({ commit }, { switchState, id }) => {
      commit('BOT_CHANGE_SWITCH', { switchState, id });
    },

    botChangeBottomBar: ({ commit }) => {
      commit('QUESTION_CHANGE_BOTTOM_BAR');
    },

    botChangeAudioData : ({ commit }, { audioData, id }) => {
      commit('BOT_CHANGE_AUDIO_DATA', { audioData, id });
    },
    deleteBot: ({ commit }, botId) => {
      commit('DELETE_BOT_ANSWERS', botId);
      commit('DELETE_BOT', botId);
      commit('DELETE_BOT_REFS', botId);
      commit('PATH_BACK');
    },
    botBackgroundChange: ({ commit }, { object, id }) => {
      commit('BOT_CHANGE_BG', { object, id });
    },
    saveToBackgroundStore: ({ commit }, data) => {
      commit('SAVE_TO_BG_STORE', data);
    },
    botPersonChange: ({ commit }, { object, id }) => {
      commit('BOT_CHANGE_PERSON', { object, id });
    },
    saveToPersonStore: ({ commit }, data) => {
      commit('SAVE_TO_PERSON_STORE', data);
    },
    botChangeVoice : ({commit}, { voice, id }) => {
      commit('BOT_CHANGE_VOICE', { voice, id });
    },


    //ANSWER
    addExistingToAnswer: ({ commit }, { answerId, nextId }) => {
      commit('ADD_EXISTING_TO_ANSWER', { answerId, nextId });
    },
    createAnswer: ({ commit }, text) => {
      commit('CREATE_NEW_ANSWER', text);
    },
    deleteAnswer: ({ commit }, answerId) => {
      commit('DELETE_ANSWER', answerId);
    },
    answerSaveText: ({ commit }, { text, id, type }) => {
      commit('ANSWER_SAVE_TEXT', { text, id, type });
    },
    answerSaveTime: ({ commit }, { time, id }) => {
      commit('ANSWER_SAVE_TIME', { time, id });
    },
    answerChangeSwitch: ({ commit }, { switchState, id }) => {
      commit('ANSWER_CHANGE_SWITCH', { switchState, id });
    },
    answerChangeAudioData : ({ commit }, { audioData, id }) => {
      commit('ANSWER_CHANGE_AUDIO_DATA', { audioData, id });
    },
    answerChangeVoice : ({commit}, { voice, id }) => {
      commit('ANSWER_CHANGE_VOICE', { voice, id });
    },
    answerChangeBottomBar: ({ commit }, index) => {
      commit('ANSWER_CHANGE_BOTTOM_BAR', index);
    },
    changeRecordDisable: ({ commit }, { disableState, id }) => {
      commit('ANSWER_CHANGE_RECORD_DISABLE', { disableState, id });
    },
    changeFeedback: ({ commit }, { feedback, id }) => {
      commit('ANSWER_CHANGE_FEEDBACK', { feedback, id });
    },
    changeFeedbackStatus: ({ commit }, { feedbackStatus, id }) => {
      commit('ANSWER_CHANGE_FEEDBACK_STATUS', { feedbackStatus, id });
    },
    changeFeedbackMessage: ({ commit }, { feedbackMessage, id }) => {
      commit('ANSWER_CHANGE_FEEDBACK_MESSAGE', { feedbackMessage, id });
    },

    //PATH
    pathBack: ({commit}) => {
      commit('PATH_BACK');
    },
    goToNextBot: ({commit}, nextId) => {
      commit('GO_TO_NEXT_BOT', nextId);
    },

    //DB
    save: ({commit, state}) => {
      return new Promise((resolve, reject) => {
        let title = state.exerciseTitle;
        if(title == '') {
          title = 'Untitled exercise';
        }

        // Filter BackgroundStore
        let botWithUploadBg = state.bots.filter(bot => {
          return bot.background.type == 'upload';
        })

        let backgroundsInUse = botWithUploadBg.map(bot => {
          return bot.background.data;
        })

        let cleanBackgroundStore = state.backgroundStore.filter(background => {
          return backgroundsInUse.includes(background.name);
        })
        // END

        // Filter PersonStore
        let botWithUploadPerson = state.bots.filter(bot => {
          return bot.person.type == 'upload';
        })

        let PersonsInUse = botWithUploadPerson.map(bot => {
          return bot.person.data;
        })

        let cleanPersonStore = state.personStore.filter(person => {
          return PersonsInUse.includes(person.name);
        })
        // END

        //Auto change Bot Audio
        let fixBots = JSON.parse(JSON.stringify(state.bots));
        fixBots.forEach(bot => {
          if(bot.audioType == 'bot' && bot.text == '') {
            bot.audioType = null;
          }
          if(bot.audioType == 'micro' && bot.recordingTime == 0) {
            bot.audioType = null;
          }
        })
        //END

        //Auto change Answer Audio
        let fixAnswers = JSON.parse(JSON.stringify(state.answers));
        fixAnswers.forEach(answer => {
          if(answer.audioType == 'bot' && answer.text == '') {
            answer.audioType = null;
          }
          if(answer.audioType == 'micro' && answer.recordingTime == 0) {
            answer.audioType = null;
          }
        })
        //END

        commit('SAVING_START');
        axios({
          method: 'post',
          url: `${process.env.VUE_APP_SERVER_URL}changeExercise`,
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token') 
          },
          data: {
            exerciseId: state.exerciseId,
            title: title,
            bots: fixBots,
            answers: fixAnswers,
            backgroundStore: cleanBackgroundStore,
            personStore: cleanPersonStore
          }
        }).then(() => {
          commit('SAVING_END');
          resolve();
        }).catch(err => {
          commit('SAVING_END');
          reject(err.response.data.error);
        })
      })
    },
    changeTitle: ({commit}, title) => {
      commit('CHANGE_TITLE', title);
    },

    //State
    loadData: ({commit}, shortId) => {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: `${process.env.VUE_APP_SERVER_URL}loadExercise`,
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token') 
          },
          data: {
            shortId
          }
        }).then(result => {
          commit('LOAD_DATA', result.data.exercise);
          resolve();
        }).catch(err => {
          reject(err.response.data.error);
        })
      })
    },
    clear: ({commit}) => {
      commit('CLEAR_STATE');
    }
  },
  getters: {
    currentBotData: (state) => {
      return state.bots.filter(bot => {
        return bot.id === state.currentBotId;
      })
    },
    currentAnswers: (state) => {
      let current = state.bots.filter(bot => {
        return bot.id === state.currentBotId;
      })
      if(current.length != 0) {
        let answers = [];
        current[0].answers.forEach(answerId => {
          let answer = state.answers.filter(answer => {
            return answer.id === answerId
          })
          answers.push(answer[0]);
        });
        return answers;
      } else {
        return [];
      }
    },
    allBots: (state) => {
      return state.bots;
    },
    allBotsWithoutCurrent: (state) => {
      // return state.bots.filter(bot => {
      //   return bot.id != state.currentBotId;
      // })
      return state.bots;
    },
    path: (state) => {
      return state.path;
    },
    getTitle: (state) => {
      return state.exerciseTitle;
    },
    checkSaving: (state) => {
      return state.saving;
    },
    getShortId: (state) => {
      return state.shortId;
    },
    getId: (state) => {
      return state.exerciseId;
    },
    getFirstBotId: (state) => {
      return state.bots[0].id;
    },
    getCurrentBotBg: (state) => {
      let currentBot = state.bots.filter(bot => {
        return bot.id === state.currentBotId;
      })
      return currentBot[0].background;
    },
    getCurrentBotPerson: (state) => {
      let currentBot = state.bots.filter(bot => {
        return bot.id === state.currentBotId;
      })
      return currentBot[0].person;
    },
    getUploadedBackground: (state) => {
      let currentBot = state.bots.filter(bot => {
        return bot.id === state.currentBotId;
      })
      let result = state.backgroundStore.find(object => {
        return object.name == currentBot[0].background.data;
      })
      if(result) {
        return result.data;
      } else {
        return '';
      }
    },
    getUploadedPerson: (state) => {
      let currentBot = state.bots.filter(bot => {
        return bot.id === state.currentBotId;
      })
      let result = state.personStore.find(object => {
        return object.name == currentBot[0].person.data;
      })
      if(result) {
        return result.data;
      } else {
        return '';
      }
    },
    getCurrentBotAudioType: (state) => {
      let currentBot = state.bots.filter(bot => {
        return bot.id === state.currentBotId;
      })
      return currentBot[0].audioType;
    },
    getBackgroundStore: (state) => {
      return state.backgroundStore;
    },
    getPersonStore: (state) => {
      return state.personStore;
    },
    getDialogId: (state) => {
      return state.exerciseId;
    },
    getActivePlayModes: (state) => {
      return state.activePlayModes;
    },
    getBottomBarState: (state) => {
      return state.bottomBarState;
    }
  }
}